export type AgentStatus = 'prod-ready' | 'experimental';

export interface GenAIAgent {
  id: string;
  name: string;
  description: string;
  status: AgentStatus;
  href?: string;
}

export const AGENT_STATUS_CONFIG = {
  'prod-ready': {
    type: 'success' as const,
    label: 'Production Ready'
  },
  'experimental': {
    type: 'warning' as const,
    label: 'Experimental'
  }
};
